import React from 'react';

// Shared table footer for onboarding list pages (matches Jobs / Candidates pagination)
const ObPagination = ({ total, currentPage, pageSize, label, onPageChange, onPageSizeChange }) => {
  const totalPages = Math.ceil((total || 0) / pageSize);

  const renderPages = () => {
    const pages = [];
    pages.push(
      <button key="prev" className="ob-page-btn" onClick={() => onPageChange(currentPage - 1)} disabled={currentPage === 1}>‹</button>
    );
    pages.push(
      <button key={1} className={`ob-page-btn${currentPage === 1 ? ' active' : ''}`} onClick={() => onPageChange(1)}>1</button>
    );
    if (currentPage > 3) pages.push(<span key="left-dots" className="ob-page-ellipsis">…</span>);
    const start = Math.max(2, currentPage - 1);
    const end = Math.min(totalPages - 1, currentPage + 1);
    for (let i = start; i <= end; i++) {
      pages.push(
        <button key={i} className={`ob-page-btn${currentPage === i ? ' active' : ''}`} onClick={() => onPageChange(i)}>{i}</button>
      );
    }
    if (currentPage < totalPages - 2) pages.push(<span key="right-dots" className="ob-page-ellipsis">…</span>);
    if (totalPages > 1) {
      pages.push(
        <button key={totalPages} className={`ob-page-btn${currentPage === totalPages ? ' active' : ''}`} onClick={() => onPageChange(totalPages)}>{totalPages}</button>
      );
    }
    pages.push(
      <button key="next" className="ob-page-btn" onClick={() => onPageChange(currentPage + 1)} disabled={currentPage === totalPages || totalPages === 0}>›</button>
    );
    return pages;
  };

  return (
    <div className="ob-pagination">
      <span className="ob-pagination-info">
        Showing {(currentPage - 1) * pageSize + 1}–{Math.min(currentPage * pageSize, total)} of <strong>{total}</strong> {label}
      </span>
      <div className="ob-pagination-right">
        <div className="ob-page-btns">{renderPages()}</div>
        <div className="ob-per-page">
          <span>Per page:</span>
          <select value={pageSize} onChange={e => onPageSizeChange(parseInt(e.target.value))}>
            <option value={10}>10</option>
            <option value={25}>25</option>
            <option value={50}>50</option>
            <option value={100}>100</option>
          </select>
        </div>
      </div>
    </div>
  );
};

export default ObPagination;
